import type { ReactNode } from 'react'
import { StyleSheet } from 'react-native'
import Animated from 'react-native-reanimated'

import { pageEntering, pageExiting } from '../utils/motion'

/**
 * One page of a step, so a move between them is a turn rather than a cut.
 *
 * - `side` is where the page sits in the flow: `ahead` arrives from and leaves
 *   to the right, `behind` the left, so the two cross as they swap.
 * - Both pages stand in the frame while the turn runs, so each fills it
 *   absolutely and the frame keeps the step's height.
 */
export function StepPage({
  side,
  animateIn = true,
  children,
}: {
  side: 'ahead' | 'behind'
  /** Off for the page the step opens on: there is nothing for it to turn from. */
  animateIn?: boolean
  children: ReactNode
}) {
  const direction = side === 'ahead' ? 1 : -1
  return (
    <Animated.View
      style={StyleSheet.absoluteFill}
      entering={animateIn ? pageEntering(direction) : undefined}
      exiting={pageExiting(direction)}
    >
      {children}
    </Animated.View>
  )
}
